<template lang="">
  <v-form ref="form" v-bind="this.$attrs" class="mt-4">
    <v-row>
      <v-col cols="6">
        <!-- <v-text-field outlined v-model="bankName" label="Ngân hàng" dense></v-text-field> -->
        <v-select
          v-model="bin"
          :items="banks"
          clear-icon="mdi-close"
          item-text="shortName"
          item-value="bin"
          label="Tên ngân hàng"
          placeholder="Chọn ngân hàng"
          outlined
          dense
          clearable
          class="required"
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          outlined
          v-model="accountNumber"
          label="Số tài khoản"
          dense
          :rules="[$rules.isNumber]"
          rul
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field outlined v-model="accountHolder" label="Tên tài khoản" dense></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    teacher: Object
  },
  data: () => ({
    bankName: '',
    accountNumber: '',
    accountHolder: '',
    bin: ''
  }),
  created() {
    this.initData()
  },
  computed: {
    ...mapState({
      banks(state) {
        return state['bankAccount'].vnBanks
      }
    })
  },
  methods: {
    initData() {
      if (this.teacher && this.teacher.data.teachBankAccount) {
        this.bankName = this.teacher.data.teachBankAccount.bankName
        this.accountNumber = this.teacher.data.teachBankAccount.accountNumber
        this.accountHolder = this.teacher.data.teachBankAccount.accountHolder
        this.bin = this.teacher.data.teachBankAccount.bin
      }
    },
    validate() {
      return this.$refs.form.validate()
    },
    getData() {
      return {
        bankName: this.bankName,
        accountNumber: this.accountNumber,
        accountHolder: this.accountHolder ? this.accountHolder.toUpperCase() : '',
        bin: this.bin
      }
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    }
  },
  formState(formState) {
    if (!formState) {
      this.initData()
    }
  }
}
</script>
<style lang=""></style>
